export interface SpaNavigationOptions {
  onNavigate: () => void;
}

export function installSpaNavigation(opts: SpaNavigationOptions): () => void {
  const origPush = history.pushState;
  const origReplace = history.replaceState;

  // Hash-only changes (Tilda menu anchors like /#prices, #operator) are
  // in-page scrolls, not navigations — they used to produce a page_view of
  // the same path and inflated depth / "returns to home".
  const pageUrl = () => location.origin + location.pathname + location.search;
  let lastUrl = pageUrl();

  function check() {
    if (pageUrl() !== lastUrl) {
      lastUrl = pageUrl();
      try {
        opts.onNavigate();
      } catch {
        // never throw out of pixel
      }
    }
  }

  history.pushState = function (this: History, ...args: Parameters<History["pushState"]>) {
    const result = origPush.apply(this, args);
    setTimeout(check, 0);
    return result;
  };

  history.replaceState = function (this: History, ...args: Parameters<History["replaceState"]>) {
    const result = origReplace.apply(this, args);
    setTimeout(check, 0);
    return result;
  };

  window.addEventListener("popstate", check);

  return () => {
    history.pushState = origPush;
    history.replaceState = origReplace;
    window.removeEventListener("popstate", check);
  };
}
